// @flow
import React from 'react';

// Pinterest logo constants
export const PINTEREST_LOGO_RADIUS = 37.8;
export const PINTEREST_LOGO_TRANSLATE_X = 277.1569;
export const PINTEREST_LOGO_TRANSLATE_Y = 0;
export const PINTEREST_LOGO_SCALE = 1;

// Pinterest logo background constants
export const PINTEREST_LOGO_BG_RADIUS_X = 38;
export const PINTEREST_LOGO_BG_RADIUS_Y = 37.8;

export const BROWSER_WINDOW_TRANSLATE_Y = 32.441;

export default () => (
  <svg
    width={440}
    height={316}
    style={{ opacity: 1, overflow: 'visible', transform: 'scale(.95)' }}
    viewBox="0 0 440 316"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M15.9508 11.963c-2.2026 0-3.9877 1.7852-3.9877 3.9878 0 2.2025 1.7851
          3.9877 3.9877 3.9877 2.2025 0 3.9877-1.7852 3.9877-3.9877 0-2.2026-1.7852-3.9877-3.9877-3.9877m-11.9631
          0c2.2025 0 3.9877 1.7851 3.9877 3.9877 0 2.2025-1.7852 3.9877-3.9877 3.9877C1.7852 19.9385 0 18.1533 0
          15.9508c0-2.2026 1.7852-3.9877 3.9877-3.9877zm23.9261 0c2.2026 0 3.9877 1.7851 3.9877 3.9877 0
          2.2025-1.7851 3.9877-3.9877 3.9877-2.2025 0-3.9876-1.7852-3.9876-3.9877 0-2.2026 1.7851-3.9877 3.9876-3.9877z"
        id="a"
      />
      <path
        d="M8.4456.6691l1.3182 4.3182h4.3945c.8974 0 1.2824 1.153.569 1.705L11.133
          9.4709l1.3475 4.4165c.2699.8827-.7398 1.5963-1.4654 1.0349l-3.466-2.6794-3.4659
          2.6794c-.7266.5614-1.7363-.1522-1.4664-1.035L3.9653 9.471.37
          6.6923c-.7124-.552-.3274-1.705.57-1.705h4.3935L6.6527.6691c.2727-.8921 1.5202-.8921 1.7929 0"
        id="b"
      />
      <path
        d="M8.0882 12.9614c-2.6756 0-4.853-2.1808-4.853-4.8606 0-2.6797 2.1774-4.8605 4.853-4.8605 2.6756 0
          4.853 2.1808 4.853 4.8605 0 2.6798-2.1774 4.8606-4.853 4.8606m10.6126
          2.3314l-3.444-3.4486c.5848-1.1203.9197-2.3921.9197-3.7434C16.1765 3.6268 12.5554 0 8.0882 0
          3.6211 0 0 3.6267 0 8.1008s3.6211 8.1009 8.0882 8.1009c1.3492 0 2.619-.3354 3.7376-.921L15.269 18.73c.948.9494
          2.4839.9494 3.4318 0 .948-.9486.948-2.4878 0-3.4372"
        id="c"
      />
      <path
        d="M0 39.5562c0 16.8872 10.5846 31.3054 25.4808 36.9784-.3626-3.0887-.7483-8.1815.0824-11.7548.7153-3.0722
          4.6182-19.5737 4.6182-19.5737s-1.1768-2.3569-1.1768-5.8477c0-5.472 3.171-9.5594 7.1234-9.5594 3.3622 0 4.984
          2.5217 4.984 5.5444 0 3.3788-2.1525 8.4288-3.2633 13.113-.9263 3.9193 1.9679 7.1167 5.8312 7.1167 6.9982 0
          12.381-7.3805 12.381-18.0343 0-9.4308-6.7772-16.0202-16.452-16.0202-11.201 0-17.7772 8.4023-17.7772 17.0882 0
          3.3854 1.302 7.0114 2.9305 8.9859.3197.3922.3692.7318.2736 1.1306-.3 1.246-.9659 3.9194-1.0944
          4.4666-.1747.7186-.5703.8735-1.3186.524-4.9181-2.2876-7.9903-9.477-7.9903-15.2521 0-12.424 9.022-23.8293
          26.0148-23.8293 13.66 0 24.2776 9.7341 24.2776 22.7415 0 13.571-8.554 24.4952-20.434 24.4952-3.992
          0-7.74-2.0767-9.0255-4.526 0 0-1.9745 7.5223-2.4525 9.3617-.9295 3.5732-3.5073 8.0958-5.106 10.6637
          3.6853 1.134 7.5948 1.7437 11.6493 1.7437 21.8449 0 39.5561-17.7112 39.5561-39.5561C79.1123 17.7112 61.4011 0
          39.5562 0 17.7112 0 0 17.7113 0 39.5562"
        id="d"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M15.12 33.6034c-7.6878 0-13.92 6.2322-13.92 13.92V300.88c0 7.6878 6.2322 13.92 13.92 13.92h409.76c7.6878 0
          13.92-6.2322 13.92-13.92V47.5234c0-7.6878-6.2322-13.92-13.92-13.92H15.12z"
        stroke="#DEDEDE"
        strokeWidth="2.4"
        fill="#FFF"
      />
      <g transform={`translate(0 ${BROWSER_WINDOW_TRANSLATE_Y})`}>
        <path
          d="M15.12 0h409.76C433.2305 0 440 6.7695 440 15.12v48.6067H0V15.12C0 6.7695 6.7695 0 15.12 0z"
          fill="#DEDEDE"
        />
        <rect fill="#FFF" x="15.5858" y="12.0152" width="218.9216" height="38.8841" rx="19.442" />
        <use fill="#FFF" xlinkHref="#a" transform="translate(384.8501 15.6198)" />
        <use fill="#DEDEDE" xlinkHref="#b" transform="translate(206.2125 24.0304)" />
        <use fill="#DEDEDE" xlinkHref="#c" transform="translate(26.376 21.6274)" />
      </g>
      <g fill="#DEDEDE">
        <rect id="content-morph" x={31} y={139} width="230.7843" height="126.3732" />
        <rect className="content-bar" x="281.4706" y="139.3346" width="126.1765" height="14.0415" />
        <rect className="content-bar" x="281.4706" y="164.1772" width="85.1961" height="14.0415" />
      </g>
      <ellipse
        fill="#FFF"
        fillOpacity="0.49"
        cx={38}
        cy={38}
        rx={PINTEREST_LOGO_BG_RADIUS_X}
        ry={PINTEREST_LOGO_BG_RADIUS_Y}
        id="pinterest-logo-pop-bg"
      />
      <g
        id="pinterest-logo"
        transform={`translate(${PINTEREST_LOGO_TRANSLATE_X}) scale(${PINTEREST_LOGO_SCALE})`}
      >
        <ellipse
          fill="#FFF"
          cx="37.8"
          cy="37.8479"
          rx={PINTEREST_LOGO_RADIUS}
          ry={PINTEREST_LOGO_RADIUS}
        />
        <g transform="translate(0 .0493)">
          <mask id="e" fill="#fff">
            <use xlinkHref="#d" />
          </mask>
          <g mask="url(#e)" fill="#E60023">
            <rect width="80.1649" height="80.1649" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
